/* eslint-disable no-prototype-builtins */
import jwtDecode from 'jwt-decode';
import { fDateDash } from './formatTime';
import conObj from './connection-assistant';

/**
 * Check if permission code exist on users allowed permissions
 * @param {Array} permission
 * @returns {Boolean}
 */
export function hasPermission(permission) {
  try {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      const { perm } = jwtDecode(accessToken);
      let isAuthorized = false;
      if (permission && perm) {
        const permList = JSON.parse(perm);
        if (permList.indexOf(permission) !== -1) {
          isAuthorized = true;
        }
      }
      return isAuthorized;
    }
  } catch (error) {
    return false;
  }

  return false;
}

/**
 * Check if variable is type Object
 * @param {Object} variable
 * @returns Boolean
 */
export const isObject = (variable) => Object.prototype.toString.call(variable) === '[object Object]';

/**
 * Reformat object for sending request data
 * @param {Object} obj
 * @returns Object
 */
export const fRequestData = (obj) => {
  const filtered = {};
  if (!isObject(obj)) return filtered;
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] !== 'undefined' && obj[key] !== null && obj[key] !== '') {
      if (Object.prototype.toString.call(obj[key]) === '[object Date]') filtered[key] = fDateDash(obj[key]);
      else if (typeof obj[key] === 'object' && obj[key]?.id) filtered[key] = obj[key]?.id;
      else filtered[key] = obj[key];
    }
  });

  return filtered;
};

/**
 * Convert object to array of formatted Object using keys parameter
 * @param {Object} obj
 * @param {Array} keys - Key names to be used where keys[0] = key and keys[1] = value
 * @returns Array Or Null
 */
export const fObjToArrayObj = (obj, keys) => {
  if (!isObject(obj)) return null;

  const arr = [];

  Object.keys(obj).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      arr.push({
        [keys[0]]: key,
        [keys[1]]: obj[key],
      });
    }
  });

  return arr;
};

export function mergeObjectsWithMatchingKey(target, source) {
  const result = { ...target };

  Object.keys(source).forEach((key) => {
    if (result.hasOwnProperty(key)) {
      if (
        source[key] !== null &&
        typeof source[key] !== 'undefined' &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key]) &&
        typeof result[key] === 'object' &&
        !Array.isArray(result[key])
      ) {
        result[key] = mergeObjectsWithMatchingKey(result[key], source[key]);
      } else {
        result[key] = source[key];
      }
    }
  });

  return result;
}

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export function checkIfQCExistToObj(obj, qcText, library, key, idKey) {
  let retVal = null;

  if (!obj?.id && qcText) {
    const isExist = library.find((x) => x[key] === qcText);
    if (isExist && isExist?.[idKey]) {
      retVal = isExist;
    }
  }

  return retVal;
}

export function checkIfQCExistToData(obj, qcText, library, key, idKey) {
  let retVal = obj?.id || qcText;

  if (!obj?.id && qcText) {
    const isExist = library.find((x) => x[key] === qcText);
    if (isExist && isExist?.[idKey]) {
      retVal = parseInt(isExist[idKey], 10);
    }
  }

  return obj?.id ? parseInt(retVal, 10) : retVal;
}

export function getOperatingSystem() {
  const { userAgent } = window.navigator;

  if (/Windows/.test(userAgent)) {
    return 'windows';
  }
  if (/Android/.test(userAgent)) {
    return 'android';
  }
  if (/Mac/.test(userAgent)) {
    return 'mac';
  }
  if (/iPhone|iPad|iPod/.test(userAgent)) {
    return 'ios';
  }
  return ''; // Return empty string for unknown or unsupported OS
}

export function isMobile() {
  const { userAgent } = window.navigator;

  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileRegex.test(userAgent);
}

export const checkIfNumberExist = async (phoneNumber) => {
  let isNumberExists = false;
  try {
    const response = await conObj.post(`forgot.json`, {
      'user-phone': phoneNumber?.replace(/\D/g, ''),
    });

    if (response.data?.data?.status === 1) isNumberExists = true;
  } catch (error) {
    isNumberExists = false;
  }

  return isNumberExists;
};

export const getFingerprint = async () => {
  let fpResult = null;
  let visitorId = null;

  try {
    // eslint-disable-next-line no-undef
    const fpPromise = await FingerprintJS.load();

    // Get the visitor identifier when you need it
    const result = await fpPromise.get();
    fpResult = result;

    // This is the visitor identifier
    // eslint-disable-next-line prefer-destructuring
    visitorId = result.visitorId;
    fpResult = JSON.stringify(fpResult);
  } catch (error) {
    console.error('Fingerprint Error:', error);
  }

  return {
    fpResult,
    visitorId,
  };
};


export function blobToFile(blob, fileName) {
  return new File([blob], fileName, { type: blob.type });
}

export function resizeInputFilePhoto(file) {
  return new Promise((resolve, reject) => {
    const quality = (Number(process.env?.REACT_APP_IMAGE_COMPRESSION_QUALITY || 80) / 100).toFixed(1);
    const maxsize = Number(process.env?.REACT_APP_IMAGE_COMPRESSION_MAXSIZE || 1024);

    // Ensure it's an image
    if (file.type.match(/image.*/)) {
      console.log(`An image has been loaded. resizing locally with parameters: maxsize=${maxsize} ; quality=${quality}`);
      // Load the image
      const reader = new FileReader();

      reader.onload = function (readerEvent) {
        const image = new Image();
        image.onload = function (imageEvent) {
          if (maxsize > image.width && maxsize > image.height) {
            // console.log(`no resize needed. current image's width=${image.width} ; height=${image.height}`);
            resolve(file);
          } else {
            // Resize the image
            const canvas = document.createElement('canvas');
            const maxSize = maxsize;
            let width = image.width;
            let height = image.height;

            // console.log(`resize needed. current image's width=${width} ; height=${height}`);

            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else if (height > maxSize) {
              width *= maxSize / height;
              height = maxSize;
            }

            // console.log(`final image's width=${width} ; height=${height}`);

            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            // resized
            // dataUrl = canvas.toDataURL('image/jpeg');
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  // console.log(`Resized file size: ${(blob.size / (1024 * 1024)).toFixed(2)} MB`);
                  // console.log(`Original file size: ${(file.size / (1024 * 1024)).toFixed(2)} MB`);
                  const compressedFile = new File(
                    [blob],
                    file.name.replace(/\.[^/.]+$/, '.png'),
                    {
                      type: 'image/png',
                      lastModified: Date.now(),
                    }
                  );

                  resolve(compressedFile);
                  // console.log('resize done');
                }
              },
              'image/png',
              quality
            );
            // const resizedImage = dataURLToBlob(dataUrl);     //console.log(dataUrl);
          }
        };

        image.src = readerEvent.target.result;
      };

      reader.readAsDataURL(file);
    } else {
      reject(Error('Not an Image'));
    }
  });
}

export const getLocalId = async () => {
  const DB_NAME = 'DeviceDB';
  const STORE_NAME = 'visitorStore';
  const KEY = 'visitorId';
  const COOKIE_NAME = 'visitorId';

  // ---- Cookie helpers ----
  const getCookie = (name) =>
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`))
      ?.split('=')[1] || null;
  const setCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  };

  // ---- IndexedDB helpers ----
  const readFromDB = () =>
    new Promise((resolve) => {
      const openReq = indexedDB.open(DB_NAME, 1);
      openReq.onupgradeneeded = (e) => e.target.result.createObjectStore(STORE_NAME);
      openReq.onsuccess = () => {
        const db = openReq.result;
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const getReq = store.get(KEY);
        getReq.onsuccess = () => resolve(getReq.result || null);
        getReq.onerror = () => resolve(null);
      };
      openReq.onerror = () => resolve(null);
    });

  const writeToDB = (value) =>
    new Promise((resolve) => {
      const openReq = indexedDB.open(DB_NAME, 1);
      openReq.onupgradeneeded = (e) => e.target.result.createObjectStore(STORE_NAME);
      openReq.onsuccess = () => {
        const db = openReq.result;
        const tx = db.transaction(STORE_NAME, 'readwrite');
        tx.objectStore(STORE_NAME).put(value, KEY);
        tx.oncomplete = () => resolve(true);
      };
      openReq.onerror = () => resolve(false);
    });

  let id = localStorage.getItem(KEY) || getCookie(COOKIE_NAME) || (await readFromDB());

  if (!id) {
    if (window.crypto?.randomUUID) {
      id = window.crypto.randomUUID();
    } else {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);

      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');

      id = `${hex.substring(0, 8)}-${hex.substring(8, 12)}-4${hex.substring(13, 16)}-a${hex.substring(
        17,
        20
      )}-${hex.substring(20, 32)}`;
    }
    console.log('🔹 New visitor ID generated:', id);
  }

  // Sync across storages
  localStorage.setItem(KEY, id);
  setCookie(COOKIE_NAME, id);
  await writeToDB(id);
  console.log('🔹 Visitor ID:', id);
  return id;
};